import * as React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Card } from '@readcloud/ui/card';
import { Input } from '@readcloud/ui/input';
import { Textarea } from '@readcloud/ui/textarea';
import { Switch } from '@readcloud/ui/switch';
import { Label } from '@readcloud/ui/label';
import { TauriImage } from '@readcloud/fetch-wrapper';
import { contentTypeConfig } from './schemas/uploadWizardConfig';
import { ContentDetailsFieldData } from './schemas/formFields';

// Check if running in Tauri environment
const isTauri = typeof window !== 'undefined' && '__TAURI__' in window;

interface IAddContentDetailsProps {
  type: string;
  thumbnail?: string;
}

const AddContentDetails: React.FunctionComponent<IAddContentDetailsProps> = ({
  thumbnail,
  type,
}) => {
  const { control } = useFormContext<ContentDetailsFieldData>();

  const details = contentTypeConfig[type]?.addDetails;

  return (
    <div className="rc-flex rc-flex-col rc-gap-4 rc-w-full">
      <Card className="rc-overflow-hidden rc-w-44 rc-h-[200px]">
        {thumbnail &&
          (isTauri ? (
            <TauriImage
              src={thumbnail}
              alt="Thumbnail"
              className="rc-w-44 rc-h-[234.47px] rc-object-cover"
            />
          ) : (
            <img
              src={thumbnail}
              alt="Thumbnail"
              className="rc-w-44 rc-h-[234.47px] rc-object-cover"
            />
          ))}
      </Card>
      <div className="rc-flex rc-flex-col rc-gap-6 rc-flex-1">
        <Controller
          control={control}
          name="title"
          render={({ field }) => (
            <div>
              <Label>Title</Label>
              <Input
                placeholder="Title"
                {...field}
                value={field.value}
                className="rc-w-full"
              />
            </div>
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <div>
              <Label>Description</Label>
              <Textarea
                placeholder="Description"
                {...field}
                className="rc-w-full"
              />
            </div>
          )}
        />

        {details?.printable && (
          <Controller
            control={control}
            name="printable"
            render={({ field }) => (
              <div className="rc-flex rc-flex-col">
                <Label>Printable</Label>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </div>
            )}
          />
        )}
        {details?.comments && (
          <Controller
            control={control}
            name="comments"
            render={({ field }) => (
              <div className="rc-flex rc-flex-col">
                <Label>Enable Comments</Label>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </div>
            )}
          />
        )}
      </div>
    </div>
  );
};

export default AddContentDetails;
